<template>
  <div class="text-center text-white text-4xl font-bold py-10">
  <!--  so wating status  -->
<p class="text-white text-4xl text-center flex justify-center mt-36">    جاري تحويلك إلى صفحة إلغاء الاشتراك...
</p>
  </div>
</template>

<script >
import { domains } from '@/domains';
import { useToast } from 'vue-toastification';

export default {
  name: "CancelSubs",
  data() {
    return {
        toat:useToast(),
        providers : domains,
    };
  },
  /**
   * @returns void
   * From the query parameter get the provider and redirect to its domain login page
   * And iform the user that they are being redirected to the provider's login page so the login first 
   * To cancel the subscription
   * If the provider is not found, show a toast message
   * 
   */
  created(){
    const provider = this.$route.query.provider;
    // check if the provider exists in the domains object
    if(provider && this.providers[provider]){
        this.toat.info('سيتم تحويلك إلى صفحة تسجيل الدخول لمزود الخدمة لإلغاء الاشتراك', {
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: true,
        });
        // redirect to the provider's domain login page
        setTimeout(() => {
          if( provider=="stripe"){
            this.$router.push('/auth/profile');
          }else{
            window.location.href = this.providers[provider];

          }
        }, 4000);
    }else{
        this.toat.error('مزود الخدمة غير معروف. يرجى المحاولة مرة أخرى.');
    }
       
  }
};

</script>

<style>

</style>